import { Dispatch, FC, SetStateAction, useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { KTSVG } from '../../../../../../../../_metronic/helpers'
import { getLast10BedsUsedByGuestService } from '../../../../services/booking.service'
import moment from 'moment'

interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  campamentoId?: string
  huespedId?: string
  onSelectBed?: (bed: any) => void
}

const ModalLastBeds: FC<Props> = ({ show, setShow, campamentoId, huespedId, onSelectBed }) => {
  const [loading, setLoading] = useState<boolean>(false)
  const [beds, setBeds] = useState<any[]>([])

  useEffect(() => {
    if (show) {
      getLastBeds()
    } else {
      setBeds([])
    }
  }, [show, campamentoId])

  const getLastBeds = async () => {
    try {
      setLoading(true)
      const filter = {
        HuespedId: huespedId || undefined,
      }
      const response = await getLast10BedsUsedByGuestService(filter)
      if (response.data) {
        // Agrupar por cama y tomar el más reciente de cada una
        setBeds(response.data as any[])
      }
    } catch (error) {
      console.error('Error getting last beds:', error)
      setBeds([])
    } finally {
      setLoading(false)
    }
  }

  const handleClose = () => {
    setShow(false)
  }

  const handleSelectBed = (bed: any) => {
    if (onSelectBed) {
      onSelectBed(bed)
    }
    handleClose()
  }

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-lg'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Últimas 10 Camas</h5>
          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          {loading ? (
            <div className='text-center py-10'>
              <div className='spinner-border text-primary' role='status'>
                <span className='visually-hidden'>Cargando...</span>
              </div>
            </div>
          ) : beds.length === 0 ? (
            <div className='text-center py-10'>
              <p className='text-muted'>No se encontraron camas recientes</p>
            </div>
          ) : (
            <div className='table-responsive'>
              <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                <thead>
                  <tr className='fw-bold text-muted'>
                    <th className='min-w-100px'>Módulo</th>
                    <th className='min-w-100px'>Habitación</th>
                    <th className='min-w-100px'>Código Cama</th>
                    <th className='min-w-100px'>Fecha(Mes/Año)</th>
                  </tr>
                </thead>
                <tbody>
                  {beds.map((bed, index) => (
                    <tr key={bed.CamaId || index}>
                      <td>
                        <span className='text-gray-600'>{bed.ModuloCodigo || '-'}</span>
                      </td>
                      <td>
                        <span className='text-gray-600'>{bed.HabitacionCodigo || '-'}</span>
                      </td>
                      <td>
                        <span className='text-gray-600'>{bed.CamaCodigo || '-'}</span>
                      </td>
                      <td>
                        <span className='text-gray-600'>{bed.Periodo || '-'}</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
        <div className='modal-footer'>
          <button type='button' className='btn btn-light' onClick={handleClose}>
            Cerrar
          </button>
        </div>
      </div>
    </Modal>
  )
}

export { ModalLastBeds }
